module.exports = __webpack_public_path__ + "img/SOKAL-SRS-120921-Clarity-Lifestyle.fe3b4039.jpeg";